$(document).ready(function(){
    $(document).on('mousemove', 'img.move', function(e){
        $(this).css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 90 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 90 +'%'});
    });
})

var pageTemp = [];
var pageMain = (function(){
    var setNavi, Moving, share, videoBg;
    var $listNavi, videoList, vTemp, youtube = false;

    videoBg = (function(t, url){
        var set, popup, list, param;

        popup = function(){
            var movieLayer = $('.layer-movie');

            $(document).on('click', '.movie-play', function(e){
                e.preventDefault();
                var youtubeId = $(this).attr('youtubeId');

                $('.layer-movie__player').append('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + youtubeId + '?rel=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>');
                movieLayer.show();
            });

            $('.layer-movie__btn-close').on('click', function(e){
                e.preventDefault();
                movieLayer.hide();
                movieLayer.find('iframe').remove();
            });
        }

        set = function(p){
            var i, t, obj;

            for( i = 0; i < Object.keys(p).length; i++){
                obj = p['v'+i];
                videoList[i] = new nc.ui.BackgroundMovie($('[data-anchor='+obj.target+'] .bg-movie'), {
                    url: obj.url,
                    movieW: 1760,
                    movieH: 990,
                    selector: 'section1Video',
                    videoControl: 'preload="auto" muted="muted"',
                    stateCallback: function(state){
                        if(state == 'ended') vTemp.play();
                    }
                });
                videoList[i].pause();
            }
        }
        return {
            init: function(){
                videoList = [], param = {};

                param['v0'] = {
                    target: 'intro',
                    url: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/aion/0628_aion_5.8update_bg_mov_0616_high.mp4'
                }
                param['v1'] = {
                    target: 'fortress-1',
                    url: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/aion/5.8_area1_BG.mp4'
                }
                param['v2'] = {
                    target: 'dungeon-1',
                    url: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/aion/5.8_area2_BG.mp4'
                }
                param['v3'] = {
                    target: 'dungeon-2',
                    url: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/aion/5.8_area3_BG.mp4'
                }

                //
                set(param);
                popup();
            }
        }
    })();

    setNavi = function(n){
        $listNavi.removeClass('active');
        $listNavi.eq(n.d1-1).addClass('active');
    };
    Moving = (function(){
        var motion, set;
        var m1 = {}, m2 = {}, m3 = {};
        var option;
        var flag = false;
        var minionTween, m_list;


        motion = (function(){
            var txt, list, multiList, navi;

            navi = function(){
                $navi = $('.page-nav li, .page-nav .link, .page-nav .btn-top');
                TweenMax.staggerFrom( $navi, 0.5, {
                    delay: 2, opacity: 0,
                    cycle:{
                        x: function(i){
                            return (i+1) * 50;
                        },
                        ease: function(i){
                            return Back.easeOut.config( i * 0.1);
                        },
                        rotationX: [-90, 90],
                        transformOrigin: ["50%, top", "50% bottom"]
                    }
                }, 0.1);
            }
            txt = function( opt, n ){
                if( m1[n] ) return m1[n].seek(0);
                m1[n] = new TimelineMax();
                m1[n].seek(0);
                m1[n].staggerFrom( opt.target, 0.5, {
                    delay: 0.3, opacity: 0, clearProps: "all",
                    cycle: {
                        y: function(i){ return (i + 1) * 70; },
                        ease: function(i){ return Back.easeOut.config( i * 0.5); }
                    }
                }, 0.1);
                m1[n].timeScale(0.5);

            };
            list = function( opt, n ){
                if( m2[n] ) return m2[n].seek(0);

                m2[n] = new TimelineMax();
                m2[n].staggerFrom( opt.target, 0.5, {
                    delay: opt.delay, opacity: 0,  clearProps: "all",
                    cycle: {
                        y: function(i){ return (i + 1) * 50; },
                        ease: function(i){ return Back.easeInOut.config( i ) }
                    }
                }, 0.1);
                m2[n].timeScale(0.5);
            };
            multiList = function( opt, n ){
                if( m3[n] ){
                    m3[n].seek(0);
                    return;
                }
                m3[n] = new TimelineMax();
                m3[n].seek(0);
                m3[n].staggerFrom( opt.target, 0.4, {
                    delay: opt.delay, opacity: 0,  clearProps: "all",
                    cycle: {
                        x: function(i){ return ( i + 1) * opt.offset; },
                        ease: function(i){ return Back.easeInOut.config( i ) }
                    }
                }, 0.1);
                m3[n].timeScale(0.6);
            };
            return {
                txt: txt,
                list: list,
                multiList: multiList,
                navi: navi
            }
        })();

        set = function (n, t){
            option = {};

            if( youtube ){
                youtube = false;
                $('#movie-player')[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            }

            switch (n.d1){
                case 1:
                    // 인트로
                    var arr = new TimelineMax();
                    if( vTemp ) vTemp.pause();
                    vTemp = videoList[0];
                    vTemp.play();

                    option['target'] = $('[data-anchor='+t+'] [data-tween="m1"]');
                    motion.txt( option );

                    arr.seek(0);
                    arr.from( $('.btn-link-arr'), 1, { delay: 1.1, opacity: 0, y: 50, ease: Back.easeInOut } );
                    arr.from( $('.btn-link-arr span'), 1, { delay: 1.3, y: 30, yoyo: true, repeat: -1 })
                    if ( flag ){ return; }
                    flag = true;
                    motion.navi();
                    break;
                case 2:
                    // 신성의 요새
                    if( vTemp ) vTemp.pause();
                    vTemp = videoList[1];
                    vTemp.play();

                    option['target'] = $('[data-anchor='+t+'] [data-tween="m1"]');
                    motion.txt( option, n.d1 );

                    option['target'] = $('[data-anchor='+t+'] [data-tween="m2"] li');
                    option['delay'] = 0.7;
                    motion.list( option, n.d1 );
                    break;
                case 3:
                    if( n.d2 == 1 ){
                        // 신성의 탑
                        if( vTemp ) vTemp.pause();
                        vTemp = videoList[2];
                        vTemp.play();

                        option['target'] = $('[data-anchor='+t+'] [data-tween="m1"]');
                        motion.txt( option, n.d1 );

                        option['target'] = $('[data-anchor='+t+'] [data-tween="m2"] li');
                        option['delay'] = 0.6;
                        motion.list( option, n.d1 );
                    }
                    else {
                        // 미라쉬 성소
                        if( vTemp ) vTemp.pause();
                        vTemp = videoList[3];
                        vTemp.play();

                        option['target'] = $('[data-anchor='+t+'] [data-tween="m1"]');
                        motion.txt( option, n.d1+'-'+n.d2 );

                        option['target'] = $('[data-anchor='+t+'] [data-tween="m2"] li');
                        option['delay'] = 0.6;
                        motion.list( option, n.d1+'-'+n.d2 );
                    }
                    break;
                case 4:
                    // 진화 아이템
                    option['target'] = $('[data-anchor='+t+'] [data-tween="m1"]');
                    motion.txt( option, n.d1 );

                    option['target'] = $('[data-anchor='+t+'] [data-tween="m2"] li');
                    option['delay'] = 1.1;
                    option['direction'] = 'x';
                    option['offset'] = '-50';
                    motion.multiList( option, n.d1 );

                    option['target'] = $('[data-anchor='+t+'] [data-tween="m3"] li');
                    option['delay'] = 1.1;
                    option['direction'] = 'x';
                    option['offset'] = '-50';
                    motion.multiList( option, n.d1+'-'+1 );

                    TweenMax.set( '[data-tween="m4"]', { opacity: 0, y: 30 });
                    TweenMax.to( '[data-tween="m4"]', 0.7, { delay: 1.5, opacity: 1, y: 0, ease: Back.easeOut });
                    break;

                case 5:
                    // 미니온
                    option['target'] = $('[data-anchor='+t+'] [data-tween="m1"]');
                    motion.txt( option, n.d1 );

                    option['target'] = $('[data-anchor='+t+'] [data-tween="m2"] li');
                    option['delay'] = 1;
                    motion.list( option, n.d1 );

                    if( minionTween ) minionTween.seek(0);
                    else {
                        m_list = $('[data-anchor=minion-1] .m-box > *');
                        minionTween = new TimelineMax( { onComplete: function(){ $('#movie-player')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*'); }} );
                        minionTween.from( m_list[0], 1, { delay: 1.2, opacity: 0, y: 100, ease: Back.easeOut });
                        minionTween.from( m_list[1], 0.5, { scale: 0, rotation: 90, opacity: 0, x: 100, ease: Power1.easeInOut }, "-=0.5");
                        minionTween.from( m_list[2], 0.5, { scale: 0, rotation: -90, opacity: 0, x: -100, ease: Power1.easeInOut }, "-=0.5");
                        minionTween.from( m_list[3], 1, { opacity: 0, x: 100, ease: Back.easeInOut }, "-=0.5");
                        minionTween.from( m_list[4], 1, { opacity: 0, x: -100, ease: Back.easeInOut }, "-=0.9");
                        minionTween.from( m_list[5], 1, { opacity: 0, y: 100, ease: Back.easeInOut }, "-=1.1");
                        minionTween.from( m_list[6], 0.5, { opacity: 0, y: 10, ease: Power1.easeInOut }, "-=0.8");
                    }

                    youtube = true;

                    break;
                case 6:
                    // 용계 신규 필드
                    option['target'] = $('[data-anchor='+t+'] [data-tween="m1"]');
                    motion.txt( option, n.d1 );

                    option['target'] = $('[data-anchor='+t+'] [data-tween="m2"] li');
                    option['delay'] = 0.6;
                    motion.list( option, n.d1 );
                    break;
                case 7:
                    if( n.d2 == 1 ){
                        // 기지전
                        option['target'] = $('[data-anchor='+t+'] [data-tween="m1"]');
                        motion.txt( option, n.d1 );

                        option['target'] = $('[data-anchor='+t+'] [data-tween="m2"] li');
                        option['delay'] = 0.6;
                        motion.list( option, n.d1 );
                    }
                    else {
                        // 레이드
                        option['target'] = $('[data-anchor='+t+'] [data-tween="m1"]');
                        motion.txt( option, n.d1+'-'+n.d2 );

                        option['target'] = $('[data-anchor='+t+'] [data-tween="m2"] li');
                        option['delay'] = 0.6;
                        motion.list( option, n.d1+'-'+n.d2 );
                    }
                    break;
            }
        };

        return {
            set: set
        };
    })();
    return {
        init: function(){
            $listNavi = $('.page-nav li');
            videoBg.init();

            fullscreen.init({
                container: '#fullscreen-ui',
                motionStyle: 'cover',
                callBack: function(_depth, _anchor){
                    setNavi(_depth);
                    Moving.set( _depth, _anchor);
                }
            });

            setTimeout(function(){
                $(".loading_bg").remove();
            }, 600);

            if( location.hash === '#intro' || location.hash === '' ){
                Moving.set( {d1: 1}, 'intro');
            }
        }
    }
})();

/**
 * module - background movie
 */
(function(exports){
    'use strict';
    var movie = function(parentNode, options){
        this._parent = parentNode;
        this._options = {
            url: '',
            selector: '',
            id: '',
            imgUrl: '',
            movieW: 640,
            movieH: 360,
            videoControl: 'autoplay="true" loop="true" preload="auto"',
            stateCallback: function(){
            }
        };

        jQuery.extend(this._options, options);

        var videoUrl = this._options.url;
        var videoType = videoUrl.substring(videoUrl.lastIndexOf('.', videoUrl.length)).toLowerCase();
        videoType = ( videoType !== '.webm' ) ? 'video/mp4' : 'video/webm';

        //비디오 지원 여부
        var tmpVideo = '<video id="' + this._options.id + '" class="' + this._options.selector + '" ' + this._options.videoControl + '" style="position:absolute;top: 0;left: 0;">' +
            '<source src="' + this._options.url + '" type="' + videoType + '" />' +
            '</video>';
        var tmplImage = '<img src="' + this._options.imgUrl + '" />';

        //비디오 지원 여부 판별
        this._node = ( this.isCanPlayType() ) ? jQuery(tmpVideo) : jQuery(tmplImage);
        this._vNode = this._node[0];
        this.bindVideoEvent();
        parentNode.append(this._node);
        this.bindEvent();
    };

    movie.prototype.isCanPlayType = function(){
        return !!document.createElement('video').canPlayType;
    };

    movie.prototype.setZindex = function(zindex){
        this._options.zindex = zindex;
        this._node.css({'z-index': zindex});
    };

    movie.prototype.volume = function(_vol){
        this._vNode.volume = _vol;
    };

    movie.prototype.isMute = function(){
        return this._node.prop('muted');
    };

    movie.prototype.setMute = function(bool){
        this._node.prop('muted', bool);
    };

    movie.prototype.muteToggle = function(){
        var bool = ( this._node.prop('muted') ) ? false : true;
        this.setMute(bool);
        return bool;
    };

    movie.prototype.play = function(_time){
        if(_time != undefined) this._vNode.currentTime = _time;
        this._vNode.play();
    };

    movie.prototype.pause = function(){
        this._vNode.pause();
    };

    movie.prototype.stop = function(){
        this._vNode.pause();
    };

    movie.prototype.toggle = function(){
        ( this._vNode.paused ) ? this._vNode.play() : this._vNode.pause();
    };

    movie.prototype.srcChange = function(_src){
        this._node.find('source').attr('src', _src);
        this._vNode.load();
        this._vNode.play();
    };

    movie.prototype.bindEvent = function(){
        //resize시 발생
        var $window = jQuery(window),
            videoMinHeight = 360,
            movieW = this._options.movieW,
            movieH = this._options.movieH,
            node = this._node,
            parent = this._parent,
            movImg = parent.find('img'),
            _this = this;

        $window.bind('resize', function(){
            var winWidth = $window.width();
            var winHeight = $window.height();
            var fixSizeW = winWidth;

            var fixSizeH = parseInt(( winWidth / movieW ) * movieH);
            if(fixSizeH < winHeight){
                fixSizeW = parseInt(( winHeight / movieH ) * movieW);
                fixSizeH = winHeight;
            }

            node.width(fixSizeW).height(fixSizeH);
            if(movImg) movImg.width(fixSizeW).height(fixSizeH);

            parent.css({left: Math.round((winWidth - fixSizeW) / 2), top: Math.round(winHeight - fixSizeH) / 2});

            if(winWidth - fixSizeW < 0){
            }
        }).trigger('resize');

        //브라우저의 해당 탭 영역이 보이지 않을 때 영상 재생 멈춤
        jQuery(document).bind('webkitvisibilitychange', function(){
            if(!_this.isCanPlayType()) return;
            if(!window._checkVisibilityChange) return;
            if(document['webkitHidden']){
                node.pause();
            } else {
                node.play();
            }
        });
    };

    movie.prototype.bindVideoEvent = function(){
        var callback = this._options.stateCallback;
        if(!this.isCanPlayType()){
            callback('error');
            return;
        }
        this._vNode.onended = function(){
            callback('ended');
        };
    };

    if(typeof exports.nc === 'undefined') exports.nc = {};
    if(typeof exports.nc.ui === 'undefined') exports.nc.ui = {};
    exports.nc.ui.BackgroundMovie = movie;
}(typeof exports === 'undefined' ? window : exports));


var mobileImageViewer = null;
(function( $ ){

    'use strict';

    function replaceOrigin( src, n ){
        if( !n ) n = 1;
        return  src.replace('.jpg', '_b'+n+'.jpg');
    }


    function popView( $self, src ){
        //이미지 뷰어 생성
        var arr = [], i, len, _src;

        len = $self.attr('maxLen'),
            _src = $self.attr('src');
        for( i = 1; i <= len; i++ ) arr.push(replaceOrigin( _src, i ));

        if( !mobileImageViewer ) mobileImageViewer = new nc.ui.ImageViewer( $( 'body' ), arr, {});
        else mobileImageViewer.setImages( arr );

        src = replaceOrigin(src);
        mobileImageViewer.slideByUrl( src );
    };

    //dom contents loaded
    $(function(){
        //이미지 클릭 이벤트
        $(document).on('click', '.ico-zoom a', function(e){
            e.preventDefault();
            popView( $(this).find('img'), $(this).find('img').attr('src') );
        });
    });
}( jQuery ));

(function(){
    var _staticPath = function(){
        var loc = location.href;
        var path = 'http://static.plaync.co.kr';
        var projectPath = '/promo/aion/update/2017/update_170628/img/';
        if(/rc\./i.test(loc)){
            path = 'http://rc.static.plaync.co.kr';
        }
        if(/local\.|localhost|opdev\.|ui-static\.|file:/i.test(loc)){
            path = 'http://ui-static.korea.ncsoft.corp'; //http://dev.static.plaync.co.kr
        }
        return path + projectPath;
    }();
    var imgList = [
        _staticPath + 'btn_line_lastbottom.png',
        _staticPath + 'btn_line_lasttop.png',
        _staticPath + 'btn_line_leftbottom.png',
        _staticPath + 'btn_line_lefttop.png',
        _staticPath + 'btn_line_rightbottom.png',
        _staticPath + 'btn_line_righttop.png',
        _staticPath + 'btn_list1_off.png',
        _staticPath + 'btn_list1_on.png',
        _staticPath + 'btn_list2_off.png',
        _staticPath + 'btn_list2_on.png',
        _staticPath + 'btn_list3_off.png',
        _staticPath + 'btn_list3_on.png',
        _staticPath + 'btn_list4_off.png',
        _staticPath + 'btn_list4_on.png',
        _staticPath + 'btn_play.png',
        _staticPath + 'copyright.png',
        _staticPath + 'etc_txt.png',
        _staticPath + 'loading_bg.png',
        _staticPath + 'loading_bi.jpg',
        _staticPath + 'logo.png',
        _staticPath + 'mask.png',
        _staticPath + 'sns.png',
        _staticPath + 'teaser_tit.png',
        _staticPath + 'teaser_txt1.png',
        _staticPath + 'teaser_txt2.png',
        _staticPath + 'teaser_txt3.png',
        _staticPath + 'teaser_txt_date.png',
        _staticPath + 'triangle.png'
    ];
    var isInitialized = false;
    var $loader;
    var $backDrop;
    var loadedImgArr = [];
    var imgURLArr = imgList;
    var loadingIndex = 0;
    var loadFailNum = 0;
    var percentageLoaded = 0;
    var completeCallback;

    function loadingStart(_loadCompleteCallback){
        if(!isInitialized){
            isInitialized = true;
            completeCallback = _loadCompleteCallback;
            loadNext();
        }
    }

    function loadNext(){
        setTimeout(function(){
            if(loadingIndex >= imgURLArr.length){
                pageMain.init();
                return;
            }
            var _img = document.createElement("img");
            _img.onload = loadCompleteHandler;
            _img.onerror = loadErrorHandler;
            _img.src = imgURLArr[loadingIndex];
        }, 100);
    }

    function loadCompleteHandler(){
        if(this) loadedImgArr.push(this);
        loadingIndex++;
        percentageLoaded = loadingIndex / imgURLArr.length * 100+"%";
        $(".loading_bg2").css({height:percentageLoaded});
        loadNext();
    }

    function loadErrorHandler(event){
        var _img = event.target;
        loadedImgArr.push(null);
        loadFailNum++;
        loadingIndex++;
        percentageLoaded = Math.floor((loadingIndex / imgURLArr.length) * 100);
        loadNext();
    }

    loadingStart();
}());



